import React from 'react';
import ProductCard from './ProductCard';
import { Product } from '../../../models';
import { NotFound } from '../../shared';

interface CatalogueByCategoryProps {
  products: Product[];
}

function CatalogueByCategory({ products }: CatalogueByCategoryProps) {
  return (
    <div>
      {products.length > 0 ? (
        <div className="w-fit flex mt-5 flex-wrap justify-center  ">
          {products.map((product) => (
            <ProductCard product={product} />
          ))}
        </div>
      ) : (
        <NotFound className="h-48 mt-32" />
      )}
    </div>
  );
}

export default CatalogueByCategory;
